import { io, Socket } from "socket.io-client";
import { BackendService } from "./Backend";
import { SessionRecordFull } from "./Api";

export class Sockets {

    private socket?: Socket;
    private sessionId?: string;
    
    constructor(
        private readonly backend: BackendService,
        /** URL na kterém poslouchá websocket server na backendu */
        private readonly apiUrl: string
    ) {}

    public initSocket(
        sessionId: string
    ) {

        if ( this.socket ) {
            return;
        }

        this.sessionId = sessionId;

        this.socket = io( this.apiUrl );

        this.socket.on( "connect", () => {
            
            console.log( "Socket connected:", this.socket?.id );

            this.socket?.emit( "join_session", this.sessionId );

        } );

        this.socket.on( "disconnect", () => {
            console.log( "Socket disconnected" );
        } );

        this.socket.on( "session_updated", () => {
            console.log( "Session updated" );
        } );

        this.socket.on( "validation_success", (data: { session: SessionRecordFull}) => {

            console.log( "Validation success", data );

            this.backend.api.onSessionChanged.call( data.session );

            this.backend.onValidationSuccess.call();

        } );

        this.socket.on( "validation_failure", (data: { session: SessionRecordFull}) => {

            console.log( "Validation failure", data );

            this.backend.api.onSessionChanged.call( data.session );

            this.backend.onShouldReset.call( true );

            this.backend.onValidationFailure.call();
            
        } );

        this.socket.on( "playback_started", () => {

            console.log( "Started playing" );

            this.backend.onStartedPlaying.call();

        } );

        this.socket.on( "playback_ended", () => {

            console.log( "Stopped playing" );

            this.backend.onStoppedPlaying.call();

        } );

    }

}